import { get, post } from "./api";

export const getProduct = (params: {slug: string}) => {
  return get('/api/v2/product', params);
};

export const getProductStripeCheckoutSession = (params: {products: any, product_group_slug: string}) => {
  return post('/api/v2/stripe/checkout_session/products', params)
}

export const getProductSaleReceipt = (params: {product_group_slug: string, uuid: string}) => {
  return get('/api/v2/product/sale/receipt', params);
}
